import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from "react-i18next";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function BarChart(props) {
  const { t } = useTranslation();

  const graphSize = props.data ? props.data.length * 45 : props.answersStats ? props.answersStats.length * 45 : 300;

  const labels = props.answersStats ?
    props.answersStats[0].answers.map(elem => elem.text) :
    props.data ? props.data.map(elem => elem.zone) : [];

  const tmpData = props.answersStats ?
    props.answersStats[0].answers.map(elem => elem.answer) : props.data ? props.data.map(elem => elem.activations) : [];

  const data = {
    labels,
    datasets: [
      {
        label: props.answersStats ? t('myExpariences.form.answerNumber') : 'Activations',
        data: tmpData,
        backgroundColor: "rgba(211, 175, 95, 1)",
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: !props.responsive,
    plugins: {
      datalabels: {
        color: 'white',
      },
      font: {
        weight: 'bold',
      },
      legend: {
        position: 'top',
        labels: {
          color: '#FFFFFFB3',
        }
      },
      title: {
        display: true,
        color: "#D3AF5F",
        text: props.answersStats ? props.answersStats[0].question : '',
        font: {
          size: 16,
        }
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#FFFFFFB3',
          stepSize: 1,
        },
        grid: {
          borderColor: '#FFFFFFB3'
        }
      },
      y: {
        ticks: {
          color: '#FFFFFFB3',
          callback: function (value) {
            // truncate the labels only in this axis
            const lbl = this.getLabelForValue(value);
            if (typeof lbl === 'string' && lbl.length > 20) {
              return `${lbl.substring(0, 20)}...`;
            }
            return lbl;
          },
        },
        grid: {
          borderColor: '#FFFFFFB3'
        }
      },
    }
  };

  return (
    <Bar
      options={options}
      data={data}
      height={graphSize <= 300 ? 350 : graphSize}
      updateMode="resize"
      width={props.responsive && 400}
    />
  );
}
